import type { PricingResult } from "@/lib/bom";
import { InfoHint } from "@/components/ui/info-hint";

const fmt = (n: number) =>
  n.toLocaleString("en-AU", { style: "currency", currency: "AUD" });

export function BomTotalsBar({
  result,
  loading,
}: {
  result: PricingResult | null;
  loading?: boolean;
}) {
  return (
    <div
      className="sticky bottom-0 flex items-center gap-4 border-t bg-background px-3 py-2 text-sm"
      data-testid="bom-totals-bar"
    >
      <InfoHint label="Live price per quantity column — unit price and line total (before GST)." />
      {loading && (
        <span data-testid="bom-totals-spinner" className="animate-spin">
          ◌
        </span>
      )}
      {(result?.columns ?? []).map((c) => (
        <span key={c.quantity}>
          Qty {c.quantity}: <strong>{fmt(c.unitPriceAud)}</strong>/u ·{" "}
          {fmt(c.totalPriceAud)}
        </span>
      ))}
      {!result?.columns?.length && (
        <span className="text-muted-foreground">No pricing yet</span>
      )}
    </div>
  );
}
